import { HomeSectionFive, Contact, ProcessCover } from '../components'

const Contacts = () => {
  return (
    <div>
      <ProcessCover/>
      <Contact/>
      <HomeSectionFive/>
    </div>
  )
}

export default Contacts
